const CHANNEL_NAME = 'impersonation-sync';
const STORAGE_KEY = 'impersonation-event';

class ImpersonationSync {
    constructor() {
        this.channel = null;
        this.useBroadcastChannel = 'BroadcastChannel' in window;
        this.lastBroadcastAction = null;
        this.lastBroadcastTime = 0;
        this.lastReceivedAction = null;
        this.lastReceivedTime = 0;
        this.COOLDOWN_MS = 1000;

        this.init();
    }

    init() {
        if (this.useBroadcastChannel) {
            this.initBroadcastChannel();
        } else {
            this.initStorageListener();
        }
    }

    initBroadcastChannel() {
        this.channel = new BroadcastChannel(CHANNEL_NAME);

        this.channel.addEventListener('message', (event) => {
            this.handleImpersonationChange(event.data);
        });
    }

    initStorageListener() {
        window.addEventListener('storage', (event) => {
            if (event.key === STORAGE_KEY && event.newValue) {
                const data = JSON.parse(event.newValue);
                this.handleImpersonationChange(data);

                setTimeout(() => localStorage.removeItem(STORAGE_KEY), 100);
            }
        });
    }

    broadcast(action, data = {}) {
        const now = Date.now();

        if (action === this.lastBroadcastAction && now - this.lastBroadcastTime < this.COOLDOWN_MS) {
            return;
        }

        const message = {
            action,
            data,
            timestamp: now,
            tabId: this.getTabId()
        };

        this.lastBroadcastAction = action;
        this.lastBroadcastTime = now;

        if (this.useBroadcastChannel && this.channel) {
            this.channel.postMessage(message);
        } else {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(message));
            setTimeout(() => localStorage.removeItem(STORAGE_KEY), 100);
        }
    }

    getTabId() {
        if (!this.tabId) {
            this.tabId = 'tab_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();
        }
        return this.tabId;
    }

    handleImpersonationChange(message) {
        if (message.tabId === this.getTabId()) {
            return;
        }

        const now = Date.now();

        if (message.action === this.lastReceivedAction && now - this.lastReceivedTime < this.COOLDOWN_MS) {
            return;
        }

        this.lastReceivedAction = message.action;
        this.lastReceivedTime = now;

        switch (message.action) {
            case 'started':
                this.handleImpersonationStarted(message.data);
                break;
            case 'stopped':
                this.handleImpersonationStopped(message.data);
                break;
        }
    }

    handleImpersonationStarted(data) {
        setTimeout(() => {
            window.location.reload();
        }, 200);
    }

    handleImpersonationStopped(data) {
        setTimeout(() => {
            window.location.reload();
        }, 200);
    }

    destroy() {
        if (this.channel) {
            this.channel.close();
        }
    }
}

const impersonationSync = new ImpersonationSync();

window.impersonationSync = impersonationSync;

export default impersonationSync;
